"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Backblaze;
    }
});
const _libstorage = require("@aws-sdk/lib-storage");
const _clients3 = require("@aws-sdk/client-s3");
const _GenericS3 = /*#__PURE__*/ _interop_require_default(require("~/plugins/GenericS3/GenericS3"));
const _constants = require("~/constants");
const _catchError = require("~/helpers/catchError");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let Backblaze = class Backblaze extends _GenericS3.default {
    get defaultParams() {
        var _this_input;
        return {
            Bucket: this.input.bucket,
            ACL: ((_this_input = this.input) == null ? void 0 : _this_input.acl) || 'public-read'
        };
    }
    async init() {
        const s3Options = {
            region: this.patchRegion(this.input.region),
            credentials: {
                accessKeyId: this.input.access_key,
                secretAccessKey: this.input.access_secret
            },
            endpoint: `https://s3.${this.patchRegion(this.input.region)}.backblazeb2.com`,
            requestChecksumCalculation: 'WHEN_REQUIRED',
            responseChecksumValidation: 'WHEN_REQUIRED'
        };
        this.s3Client = new _clients3.S3(s3Options);
    }
    patchKey(key) {
        if (_constants.S3_PATCH_KEYS.some((k)=>key.startsWith(`${this.input.bucket}/nc/${k}`))) {
            key = key.replace(`${this.input.bucket}/`, '');
        }
        return key;
    }
    async upload(uploadParams) {
        try {
            const upload = new _libstorage.Upload({
                client: this.s3Client,
                params: uploadParams
            });
            const data = await upload.done();
            if (data) {
                return `https://${this.input.bucket}.s3.${this.input.region}.backblazeb2.com/${uploadParams.Key}`;
            }
        } catch (error) {
            _catchError.NcError._.storageFileCreateError(error.message);
        }
    }
    patchRegion(region) {
        // in v0.0.1, we constructed the endpoint with `region = s3.us-west-001`
        // in v0.0.2, `region` would be `us-west-001`
        // as backblaze states Region is the 2nd part of your S3 Endpoint in documentation
        if (region.startsWith('s3.')) {
            region = region.slice(3);
        }
        return region;
    }
    constructor(input){
        super(input), this.name = 'Backblaze';
    }
};
